import { Injectable } from "@angular/core";
import { Store as NgrxStore } from "@ngrx/store";
import type { UserState } from "./user";
import type { ChallengesState } from "./challenges";
import type { CountriesState } from "./countries";
import { NewChallengeState } from "./new-challenge-creation/new-challenge.reducer";
import { UpgradeChallengeState } from "./upgrade-challenge-creation/upgrade-challenge.reducer";
import { FuturesNewChallengeState } from "./futures-new-challenge/futures-new-challenge.reducer";

export interface AppState {
  user: UserState;
  challenges: ChallengesState;
  countries: CountriesState;
  newChallenge: NewChallengeState;
  upgradeChallenge: UpgradeChallengeState;
  futuresNewChallenge: FuturesNewChallengeState;
}

@Injectable({ providedIn: "root" })
export class Store extends NgrxStore<AppState> {}
